import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../../hooks/useSettings";
import { useBackgroundType } from "../../hooks/useBackgroundType";

const Logo = ({ imageUrl, logoClass, backgroundType: propBackgroundType }) => {
  const { logoLight, logoDark } = useSettings();
  const detectedBackgroundType = useBackgroundType();

  // Use prop backgroundType if provided, otherwise use detected backgroundType
  const backgroundType = propBackgroundType || detectedBackgroundType;

  // Determine which logo to use based on background type
  let logoUrl = imageUrl; // Use prop if provided

  if (!logoUrl) {
    switch (backgroundType) {
      case "light":
        logoUrl = logoDark; // Use dark logo on light background
        break;
      case "dark":
        logoUrl = logoLight; // Use light logo on dark background
        break;
      default:
        logoUrl = logoDark; // Default to dark logo (assuming light background)
        break;
    }
  }

  return (
    <div
      className={`${logoClass ? logoClass : ""}`}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "100%",
      }}
    >
      <Link to={process.env.PUBLIC_URL + "/"}>
        <img
        style={{maxWidth:'226px',maxHeight:'34px',objectFit:'contain'}}
          alt=""
          src={window.innerWidth<='1000'?logoDark:logoUrl}
        />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string,
  backgroundType: PropTypes.oneOf(["light", "dark"]),
};

export default Logo;
